import { observer } from "mobx-react";
import React, { useCallback } from "react";
import { StyleSheet } from "react-native";
import { Spacer } from "~/components/Spacer";
import { BodyText } from "~/components/V2/Text/BodyText";
import { BrandText } from "~/components/V2/Text/BrandText";
import { View } from "~/components/V2/View";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import { ButtonCircle } from "./ButtonCircle";
import { Chip } from "./Chip";
import { Pressable } from "./Pressable";
import type { PressableStateCallbackType, TextStyle } from "react-native";

const S = StyleSheet.create({
  subtitle: {
    lineHeight: 20,
    fontSize: 14,
  },
  title: {
    lineHeight: 28,
    fontSize: 20,
  },
  textContainer: { width: "100%" },
});

export const Card = observer(function Card({
  title,
  subtitle,
  onPress,
  titleStyle,
  subtitleStyle,
  distance,
}: {
  title: string;
  subtitle: string;
  onPress: () => void;
  titleStyle?: TextStyle;
  subtitleStyle?: TextStyle;
  distance?: string;
}) {
  const resolveBackgroundColor = useCallback(
    (state: PressableStateCallbackType) => {
      if (state.pressed) {
        return styleConstantsV2.colorPrimaryHoverLight;
      }
      if (state.hovered) {
        return styleConstantsV2.colorPrimaryHoverLight;
      }

      return styleConstantsV2.colorPrimaryBg;
    },
    [],
  );

  return (
    <Pressable
      onPress={onPress}
      style={(state) => {
        return {
          backgroundColor: resolveBackgroundColor(state),
          paddingVertical: styleConstantsV2.spacing24,
          paddingHorizontal: styleConstantsV2.spacing16,
          borderRadius: styleConstantsV2.borderRadius4,
        };
      }}
    >
      {/* @ts-ignore  */}
      {({ hovered }: Omit<PressableState, "focused">) => {
        return (
          <>
            <View flexDirectionRow>
              <View flex>
                <View flexDirectionRow alignItemsCenter>
                  <View flex>
                    <BrandText
                      sizeH3
                      weightBold
                      colorBlack
                      style={{ ...S.title, ...titleStyle }}
                    >
                      {title}
                    </BrandText>
                  </View>

                  <ButtonCircle
                    iconName="chevron-right"
                    size="small"
                    pointerEvents="none"
                  />
                </View>
                <Spacer extraSmall />
                <View flexDirectionRow alignItemsCenter>
                  <BodyText
                    sizeLarge
                    weightRegular
                    colorBlack
                    style={{ ...S.subtitle, ...subtitleStyle }}
                  >
                    {subtitle}
                  </BodyText>
                </View>
              </View>
            </View>
            {distance && (
              <View style={{ position: "absolute", left: 10, top: -16 }}>
                <Chip
                  size="small"
                  iconPosition="left"
                  iconName="location"
                  backgroundColor={
                    hovered
                      ? styleConstantsV2.colorGrey30
                      : styleConstantsV2.colorGrey20
                  }
                  title={intl.formatMessage(
                    {
                      id: "xXiurs",
                      defaultMessage: "{distance} km",
                      description: "Welcome message with user's name",
                    },
                    { distance },
                  )}
                />
              </View>
            )}
          </>
        );
      }}
    </Pressable>
  );
});
